@let buttonIconPadding = 10;

<div class="work-ui-image-annotator">
  <!-- Oben: Verlassen, Verlauf, Speichern. Unten (mit dem Daumen erreichbar): Werkzeuge, Farbe, Strichstärke. -->
  <div class="work-ui-image-annotator__bar work-ui-image-annotator__bar--top">
    <work-ui-button (buttonClick)="requestClose()"
                    [iconOnly]="true"
                    [iconPadding]="buttonIconPadding"
                    [tooltipDescription]="'ABBRECHEN' | translate"
                    iconName="close"
                    variant="tertiary-white" />

    <div class="work-ui-image-annotator__group">
      <work-ui-button (buttonClick)="undo()"
                      [disabled]="!canUndo()"
                      [iconOnly]="true"
                      [iconPadding]="buttonIconPadding"
                      [tooltipDescription]="'BILD_BESCHRIFTEN_RUECKGAENGIG' | translate"
                      iconName="undo"
                      variant="tertiary-white" />
      <work-ui-button (buttonClick)="redo()"
                      [disabled]="!canRedo()"
                      [iconOnly]="true"
                      [iconPadding]="buttonIconPadding"
                      [tooltipDescription]="'BILD_BESCHRIFTEN_WIEDERHOLEN' | translate"
                      iconName="redo"
                      variant="tertiary-white" />
      @if (selectedIndex() !== null) {
        <work-ui-button (buttonClick)="deleteSelected()"
                        [iconOnly]="true"
                        [iconPadding]="buttonIconPadding"
                        [tooltipDescription]="'BILD_BESCHRIFTEN_ELEMENT_LOESCHEN' | translate"
                        iconName="delete"
                        variant="tertiary-white" />
      }
    </div>

    <work-ui-button (buttonClick)="save()"
                    [disabled]="isImageLoading() || imageLoadFailed()"
                    [loadingState]="saveLoadingState()"
                    iconName="check"
                    text="SPEICHERN" />
  </div>

  <div #stageContainer class="work-ui-image-annotator__stage"></div>

  @if (isImageLoading()) {
    <work-ui-loading-spinner [iconSize]="64" [pageOverlay]="true" loadingState="loading" theme="white" />
  }
  @if (imageLoadFailed()) {
    <div class="work-ui-image-annotator__message work-text-color-white flex flex-column gap-12 vertical-center">
      <work-ui-icon [fontSize]="56" name="broken_image" />
      <p>{{ 'BILD_BESCHRIFTEN_BILD_NICHT_GELADEN' | translate }}</p>
    </div>
  }

  @if (textEdit()) {
    <form (ngSubmit)="confirmTextEdit()"
          [formGroup]="textEditForm"
          class="work-ui-image-annotator__text-edit work-card flex vertical-center gap-8">
      <work-ui-input-field #textInputField
                           formControlName="text"
                           [placeholder]="textEditPlaceholder()"
                           class="flex-1" />
      <work-ui-button (buttonClick)="cancelTextEdit()" text="ABBRECHEN" variant="tertiary" />
      <work-ui-button text="OK" type="submit" />
    </form>
  }

  <div class="work-ui-image-annotator__bar work-ui-image-annotator__bar--bottom">
    <div class="work-ui-image-annotator__tools">
      @for (toolOption of TOOL_OPTIONS; track toolOption.tool) {
        <work-ui-button (buttonClick)="selectTool(toolOption.tool)"
                        [iconName]="toolOption.iconName"
                        [iconOnly]="true"
                        [iconPadding]="buttonIconPadding"
                        [tooltipDescription]="toolOption.label | translate"
                        [variant]="tool() === toolOption.tool ? 'primary' : 'tertiary-white'" />
      }
    </div>
    <div class="work-ui-image-annotator__styles">
      <div [workUiTooltip]="'BILD_BESCHRIFTEN_FARBE' | translate" class="work-ui-image-annotator__group">
        @for (annotationColor of ANNOTATION_COLORS; track annotationColor) {
          <button (click)="selectColor(annotationColor)"
                  [attr.aria-label]="annotationColor"
                  [class.work-ui-image-annotator__color--active]="color() === annotationColor"
                  [style.background-color]="annotationColor"
                  class="work-ui-image-annotator__color"
                  type="button"></button>
        }
      </div>
      <div [workUiTooltip]="'BILD_BESCHRIFTEN_STRICHSTAERKE' | translate" class="work-ui-image-annotator__group">
        @for (annotationSizeFactor of ANNOTATION_SIZE_FACTORS; track annotationSizeFactor; let sizeIndex = $index) {
          <button (click)="selectSizeFactor(annotationSizeFactor)"
                  [attr.aria-label]="'BILD_BESCHRIFTEN_STRICHSTAERKE' | translate"
                  [class.work-ui-image-annotator__size--active]="sizeFactor() === annotationSizeFactor"
                  class="work-ui-image-annotator__size"
                  type="button">
            <span [style.height.px]="4 + sizeIndex * 4" class="work-ui-image-annotator__size-line"></span>
          </button>
        }
      </div>
    </div>
  </div>

  <!-- Innerhalb des Editors, damit die Rückfrage über dem Vollbild liegt (der Editor stapelt über --z-index-modal). -->
  <work-ui-modal #unsavedChangesModal
                 [hideCloseButton]="true"
                 [introText]="'BILD_BESCHRIFTEN_UNGESPEICHERT_TEXT' | translate"
                 [modalWidth]="'small'"
                 [titleText]="'BILD_BESCHRIFTEN_UNGESPEICHERT_TITEL' | translate"
                 modalId="imageAnnotatorUnsavedChangesModal">
    <ng-container modal-footer>
      <div class="flex flex-column gap-12 width-100">
        <work-ui-button (buttonClick)="saveFromUnsavedChangesModal()" [fullWidth]="true" text="SPEICHERN" />
        <work-ui-button (buttonClick)="discardChanges()" [fullWidth]="true" text="VERWERFEN" variant="secondary" />
        <work-ui-button (buttonClick)="continueEditing()" [fullWidth]="true" text="WEITER_BEARBEITEN" variant="tertiary" />
      </div>
    </ng-container>
  </work-ui-modal>
</div>
